/* Judge.me review anchor + star-badge scroll, for the CHAMFER PDP.

   Two jobs:
     1. Judge.me's star badge should scroll to that product's own review
        widget. Judge.me ships its own click handler, but it computes
        against the window.
     2. Sub-nav links pointing at #reviews must still land correctly when
        the review slot is a Judge.me app block, which renders no element
        with id="reviews".

   THE SCROLL CONTAINER IS NOT THE WINDOW AT >=990px.
   Horizon's base.css clips html/body and makes .page-wrapper the scroller.
   Scrolling the window instead leaves everything inside .page-wrapper where
   it was while the clipped document scrolls internally - the page appears
   blank with no way to recover but a reload. assets/ref-pdp.js documents
   this at length; this file mirrors its scrollTarget() logic deliberately.
   Keep the two in sync if Horizon changes the breakpoint.

   Handlers are delegated and registered in the CAPTURE phase so they work
   on markup Judge.me hydrates after load, and so they win over Judge.me's
   own window-based handler. */
(function () {
  'use strict';

  var SQUEEZE = window.matchMedia('(min-width: 990px)');
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function scrollTarget() {
    if (SQUEEZE.matches) {
      return document.querySelector('.page-wrapper') || document.scrollingElement || document.documentElement;
    }
    return document.scrollingElement || document.documentElement;
  }

  function scrollTopOf(t) {
    if (t && t !== document && typeof t.scrollTop === 'number') return t.scrollTop;
    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  function offset() {
    var nav = document.querySelector('.pdp-nav');
    return nav ? nav.getBoundingClientRect().height + 8 : 16;
  }

  /* Prefer a real #reviews element; fall back to Judge.me's own container so
     the anchor lands correctly where the slot is an app block. */
  function reviewsEl() {
    return document.getElementById('reviews')
      || document.querySelector('#judgeme_product_reviews')
      || document.querySelector('.jdgm-review-widget')
      || document.querySelector('.jdgm-widget.jdgm-review-widget');
  }

  function scrollToEl(el) {
    if (!el) return false;
    var target = scrollTarget();
    var elTop = el.getBoundingClientRect().top;
    var containerTop = (target === document || target === document.documentElement)
      ? 0
      : target.getBoundingClientRect().top;
    var y = elTop - containerTop + scrollTopOf(target) - offset();
    target.scrollTo({ top: y, behavior: REDUCE ? 'auto' : 'smooth' });
    return true;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var badge = t.closest('.jdgm-preview-badge');
    var link = t.closest('a[href="#reviews"]');
    if (!badge && !link) return;

    var el = reviewsEl();
    if (!el) return;
    if (scrollToEl(el)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})();
